import toggleModal from '../utils/toggle-modal';

document.addEventListener('DOMContentLoaded', () => {

    let header = $('.js-header'),
        menuBtn = $('.js-menu-btn'),
        mainMenu = $('.js-main-menu'),
        headerWrap = $('.header-wrap');

    // scroll

    (() => {

        let scroll = window.requestAnimationFrame;

        function scrollWindow() {

            let st = $(window).scrollTop();

            if (st > 15) {

                header.addClass('hide-content');

            } else {

                header.removeClass('hide-content');

            }

            scroll(scrollWindow);

        }

        scrollWindow();

    })();

    function closeMenu() {

        header.removeClass('hide-onclick');
        menuBtn.removeClass('transform-hamburger');
        headerWrap.removeClass('show-wrap');
        mainMenu.removeClass('slide-menu');
        toggleModal(false, '.header__slide');

    }


    menuBtn.click( () => {

        if (menuBtn.hasClass('transform-hamburger')) {

            closeMenu();

        } else {

            if (!header.hasClass('hide-content')) {
                header.addClass('hide-onclick');
            }
            menuBtn.addClass('transform-hamburger');
            headerWrap.addClass('show-wrap');
            mainMenu.addClass('slide-menu');
            toggleModal(true, '.header__slide');

        }

    });

    $(document).on('click', (e) => {

        if (!$(e.target).closest(menuBtn).length && !$(e.target).closest(mainMenu).length) {

            closeMenu();

        }

    });

});


// WEBPACK FOOTER //
// ./scripts/elements/header-nav.js